var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSemibox = function SvgSemibox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 112 72"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8a4 4 0 0 1 4-4h18v64H8a4 4 0 0 1-4-4z",
    className: "semibox_svg__svg-slate-200"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 8,
    x: 30,
    y: 4,
    className: "semibox_svg__svg-slate-200",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17,
    x: 30,
    y: 16,
    className: "semibox_svg__svg-slate-200",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 17,
    x: 59,
    y: 16,
    className: "semibox_svg__svg-slate-200",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 23,
    x: 30,
    y: 37,
    className: "semibox_svg__svg-slate-200",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 4,
    x: 30,
    y: 64,
    className: "semibox_svg__svg-slate-200",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    x: 10,
    y: 10,
    className: "semibox_svg__svg-slate-300",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 6,
    y: 28,
    className: "semibox_svg__svg-slate-300",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 6,
    y: 36,
    className: "semibox_svg__svg-slate-300",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 6,
    y: 44,
    className: "semibox_svg__svg-slate-300",
    rx: 1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 4,
    x: 6,
    y: 52,
    className: "semibox_svg__svg-slate-300",
    rx: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 8,
    r: 2,
    className: "semibox_svg__svg-slate-300"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 8,
    r: 2,
    className: "semibox_svg__svg-slate-300"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 8,
    r: 2,
    className: "semibox_svg__svg-slate-300"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 8,
    r: 2,
    className: "semibox_svg__svg-slate-300"
  })));
};
export default SvgSemibox;